export const column = '--grid-container-column';
export const spacing = '--grid-container-spacing';
